import { api } from './axios'
import type { Usuario, Parceiro, ParceiroVinculado } from '@/types'

interface SessaoParceiro {
  usuario: Usuario
  /** Null quando o usuário tem mais de um vínculo e ainda não escolheu por qual opera. */
  parceiro: Parceiro | null
  /** Todos os vínculos do usuário — alimenta a escolha e o "Trocar parceiro". */
  parceiros?: ParceiroVinculado[]
  isAdministrador?: boolean
  podeConfigurarNewDriver?: boolean
  /** Só vem no login: a senha digitada eram os 6 primeiros dígitos do CPF. */
  usandoSenhaPadrao?: boolean
}

export async function login(cpf: string, senha: string) {
  const response = await api.post<SessaoParceiro>('/usuarios/login', {
    cpf,
    senha,
  })
  return response.data
}

export async function logout() {
  await api.post('/usuarios/logout')
}

export async function getSession() {
  const response = await api.get<SessaoParceiro & { usuario: Usuario | null }>('/usuarios/session')
  return response.data
}

/** O endpoint responde com o token cru, não com um objeto — frontend-adm também depende disso. */
export async function criaTokenMudancaSenha(usuarioId: number): Promise<string> {
  const response = await api.put<string>('/usuarios/cria-token-mudanca-senha', { usuarioId })
  return response.data
}

/**
 * Sessão nascida do Hyperpay: o loginToken chega pela URL do iframe e vale um minuto. Trocá-lo por
 * sessão é o único uso possível dele.
 */
export async function trocarLoginTokenPorSessao(loginToken: string): Promise<SessaoParceiro> {
  const response = await api.post<SessaoParceiro>('/usuarios/exchange-sso-parceiro', { loginToken })
  return response.data
}

export async function alterarSenha(senhaAtual: string, novaSenha: string) {
  await api.post('/usuarios/altera-senha', { senhaAtual, novaSenha })
}
